module.exports = __webpack_public_path__ + "files/62723c5634fa93c7f725b1d510ec325f.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people.png
// module id = 478
// module chunks = 60